import { call, put, takeEvery, select } from 'redux-saga/effects';
import { getPropertySuccess } from '../actions/propertyActions';
import * as types from '../actions/actionType';
import { withApiErrorHandling } from '../helpers/sagaHelper';
import session from 'containers/App/session';
import { statsService } from 'utils/api';

export function* getOTAInsightsByDay(action) {
    const token = yield select(session.selectors.selectUserToken);
    yield* withApiErrorHandling(function* fetchOTAInsightsByDay() {
        const response = yield call(statsService({ token, propertyId: action.id }).getDailyOTAInsightsWithChange, {
            today: action.date,
        });
        yield put(getPropertySuccess(types.GET_OTA_INSIGHTS_DAILY_SUCCESS, response.data));
    });
}

export function* watchGetOTAInsightsByDay() {
    yield takeEvery(types.GET_OTA_INSIGHTS_DAILY, getOTAInsightsByDay);
}
